import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalculateFsm = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4A5666",
		fillRule: "evenodd",
		d: "M13.286 12.239a.9.9 0 1 0-1.272 1.272l1.613 1.614-1.613 1.614a.9.9 0 1 0 1.272 1.272l1.614-1.613 1.614 1.613a.9.9 0 1 0 1.272-1.272l-1.613-1.614 1.613-1.614a.9.9 0 1 0-1.272-1.272L14.9 13.852zm-1.089-8.814a.9.9 0 0 0-.897.9c0 .5.402.9.897.9H14v1.803a.9.9 0 0 0 .9.897c.5 0 .9-.402.9-.897V5.225h1.803a.9.9 0 0 0 .897-.9c0-.5-.402-.9-.897-.9H15.8V1.622a.9.9 0 0 0-.9-.897c-.5 0-.9.402-.9.897v1.803zM.5 4.325a.9.9 0 0 1 .897-.9h5.406c.495 0 .897.4.897.9a.9.9 0 0 1-.897.9H1.397a.896.896 0 0 1-.897-.9m0 12.15a.9.9 0 0 1 .897-.9h5.406c.495 0 .897.4.897.9a.9.9 0 0 1-.897.9H1.397a.896.896 0 0 1-.897-.9m0-2.7a.9.9 0 0 1 .897-.9h5.406c.495 0 .897.4.897.9a.9.9 0 0 1-.897.9H1.397a.896.896 0 0 1-.897-.9"
	})
});
export default SvgCalculateFsm;
